export default __webpack_public_path__ + "static/media/bitstop-app-apple-store-qr.3fc8bd37.png";